import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\SAManagement\GetTenantDumpsController::__invoke
* @see app/Http/Controllers/SAManagement/GetTenantDumpsController.php
* @route '/api/sa-management/command-runner/tenant-dumps'
*/
const GetTenantDumpsController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetTenantDumpsController.url(options),
    method: 'get',
})

GetTenantDumpsController.definition = {
    methods: ["get","head"],
    url: '/api/sa-management/command-runner/tenant-dumps',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SAManagement\GetTenantDumpsController::__invoke
* @see app/Http/Controllers/SAManagement/GetTenantDumpsController.php
* @route '/api/sa-management/command-runner/tenant-dumps'
*/
GetTenantDumpsController.url = (options?: RouteQueryOptions) => {
    return GetTenantDumpsController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SAManagement\GetTenantDumpsController::__invoke
* @see app/Http/Controllers/SAManagement/GetTenantDumpsController.php
* @route '/api/sa-management/command-runner/tenant-dumps'
*/
GetTenantDumpsController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetTenantDumpsController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SAManagement\GetTenantDumpsController::__invoke
* @see app/Http/Controllers/SAManagement/GetTenantDumpsController.php
* @route '/api/sa-management/command-runner/tenant-dumps'
*/
GetTenantDumpsController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetTenantDumpsController.url(options),
    method: 'head',
})

export default GetTenantDumpsController